import { RouteRecordRaw } from 'vue-router'
import EpisodView from '../../components/Sport/Episod/EpisodView.vue'
import SanctuaryView from '../../components/Sport/Sanctuary/SanctuaryView.vue'
import HomeView from '../../components/Sport/HomeView.vue'
import AccountView from '../../components/Sport/AccountView.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'home_sport',
        component: HomeView,
    },
    {
        path: '/episod',
        name: 'episod',
        component: EpisodView,
    },
    {
        path: '/sanctuary',
        name: 'sanctuary',
        component: SanctuaryView,
    },
    {
        path: '/account',
        name: 'sport_account',
        component: AccountView,
    },
]

export default routes
